import {
  DefaultAudioMixController,
  TimeoutScheduler
} from "amazon-chime-sdk-js";

export class TestSound {
  constructor(
    sinkId: string | null,
    frequency = 440,
    durationSec = 1,
    rampSec = 0.1,
    maxGainValue = 0.1
  ) {
    const audioContext: AudioContext = new (window.AudioContext ||
      (window as any).webkitAudioContext)();
    const gainNode = audioContext.createGain();
    gainNode.gain.value = 0;
    const oscillatorNode = audioContext.createOscillator();
    oscillatorNode.frequency.value = frequency;
    oscillatorNode.connect(gainNode);
    const destinationStream = audioContext.createMediaStreamDestination();
    gainNode.connect(destinationStream);
    const currentTime = audioContext.currentTime;
    const startTime = currentTime + 0.1;
    gainNode.gain.linearRampToValueAtTime(0, startTime);
    gainNode.gain.linearRampToValueAtTime(maxGainValue, startTime + rampSec);
    gainNode.gain.linearRampToValueAtTime(
      maxGainValue,
      startTime + rampSec + durationSec
    );
    gainNode.gain.linearRampToValueAtTime(
      0,
      startTime + rampSec * 2 + durationSec
    );
    oscillatorNode.start();
    this.setupAudioMixController(sinkId, destinationStream);
    new TimeoutScheduler((rampSec * 2 + durationSec + 1) * 1000).start(() => {
      audioContext.close();
    });
  }

  async setupAudioMixController(
    sinkId: string | null,
    destinationStream: MediaStreamAudioDestinationNode
  ) {
    const audioMixController = new DefaultAudioMixController();
    const deviceInfo = sinkId
      ? ({ deviceId: sinkId } as MediaDeviceInfo)
      : null;
    await audioMixController.bindAudioDevice(deviceInfo);
    await audioMixController.bindAudioElement(new Audio());
    await audioMixController.bindAudioStream(destinationStream.stream);
  }
}
